import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';

export const getJobTimePromptEnabled = createSelector(
  [getCompanySettings],
  (companySettings) => {
    return companySettings?.jobTimePromptEnabled ?? false;
  }
);
